import { render } from "./RegisterView.vue?vue&type=template&id=21fda9ce&scoped=true"
import script from "./RegisterView.vue?vue&type=script&lang=js"
export * from "./RegisterView.vue?vue&type=script&lang=js"

import "./RegisterView.vue?vue&type=style&index=0&id=21fda9ce&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fda9ce"]])

export default __exports__